module.exports = __webpack_public_path__ + "static/img/api.c58c38c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/api.svg
// module id = 9N+0
// module chunks = 15